import * as Yup from 'yup';

export default () =>
	Yup.object().shape({
		age_group: Yup.string().required('Grupa wiekowa jest wymagana'),
		country: Yup.string().required('Kraj jest wymagany')
	});
